import * as React from 'react';

import { Image } from './careers-intro-triangle2.styles';

export const Triangle2View = ({ imageSrc }) => <Image src={imageSrc} alt="" />;
